import "angular:locale/data:cs";
import "@angular/localize/init";(globalThis.$localize ??= {}).locale = "cs";
